module.exports = __webpack_public_path__ + "static/media/youtube.2e19d6a9.svg";